import request from '../../utils/request.ts';
import { FilterOptionsType } from './types.ts';
import { toast } from 'react-toastify';

export const getDestinations = () =>
  request(`api/lookup/getDestinations`)
    .then((res) => res)
    .catch((error) => {
      toast(error.message || 'Request failed', { type: 'error' });
    });

export const getSuppliers = (destinationId: number | null) =>
  request(`api/lookup/GetHtiEresSuppliers?destinationId=${destinationId}`)
    .then((res) => res)
    .catch((error) => {
      toast(error.message || 'Request failed', { type: 'error' });
    });

export const checkAvailability = (data: FilterOptionsType) =>
  request(`api/serviceproperty/GetLiveAvailability`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((res) => res)
    .catch((error) => {
      console.error(error);
    });
